module.exports = __webpack_public_path__ + "static/media/burger.4fe104e4.png";